var React = require('react');

function Filters (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13.588 4.58V1.433c0-.24-.2-.433-.45-.433h-.449a.441.441 0 0 0-.45.434V4.58c-.785.268-1.348.991-1.348 1.84 0 .85.563 1.573 1.349 1.84v6.184c0 .24.2.434.45.434h.449c.248 0 .45-.194.45-.434V8.26c.785-.268 1.348-.991 1.348-1.84 0-.85-.563-1.573-1.349-1.84zM8.643 8.483v-7.05c0-.24-.201-.433-.45-.433h-.45a.442.442 0 0 0-.449.434v7.05c-.786.267-1.349.99-1.349 1.84 0 .85.563 1.572 1.35 1.84v2.28c0 .24.2.434.449.434h.45c.248 0 .449-.194.449-.434v-2.28c.786-.268 1.349-.99 1.349-1.84 0-.85-.563-1.573-1.349-1.841zM3.698 4.58V1.433A.442.442 0 0 0 3.248 1h-.45a.442.442 0 0 0-.45.434V4.58C1.564 4.848 1 5.571 1 6.42c0 .85.563 1.573 1.349 1.84v6.184c0 .24.201.434.45.434h.449c.248 0 .45-.194.45-.434V8.26c.785-.268 1.348-.991 1.348-1.84 0-.85-.563-1.573-1.348-1.84z"}));
}

Filters.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16"};

module.exports = Filters;

Filters.default = Filters;
